module.exports = __webpack_public_path__ + "img/ad_coupon_2@2x.1d0cf801.png";